import TopNav from "../components/TopNav.jsx";
import ProductMark from "../components/ProductMark.jsx";
import FreeConsultWidget from "../components/FreeConsultWidget.jsx";

/**
 * CompassPage · /compass
 * Free forever · public-records + FOIA drafter and search-query helper.
 * Sends you elsewhere on purpose — Sage is the compass, not the destination.
 */
export default function CompassPage() {
  return (
    <div className="min-h-screen bg-sage-bg text-sage-text sage-grain" data-testid="compass-page">
      <TopNav />
      <div className="mx-auto max-w-4xl px-4 md:px-8 py-12">
        <div className="text-[10px] uppercase tracking-[0.3em] text-sage-accent mb-3">FREE FOREVER · CIVIC TIER</div>
        <div className="flex items-start gap-4 mb-4">
          <div className="text-sage-accent shrink-0"><ProductMark slug="compass" size={48} /></div>
          <h1 className="text-4xl md:text-5xl font-bold tracking-tighter uppercase">Compass</h1>
        </div>
        <p className="text-lg text-sage-muted leading-relaxed max-w-3xl mb-10 sage-prose">
          The free surveyor. Compass helps you find public records, write a FOIA request that actually gets answered, and search the open web with the right words. Sage points you at the source — always somewhere else on purpose.
        </p>

        <div className="border border-sage-border p-6 mb-10">
          <div className="text-xs uppercase tracking-[0.15em] text-sage-muted mb-3">What Compass does</div>
          <ul className="list-disc list-inside text-sm text-sage-text space-y-2 sage-prose">
            <li>Drafts a FOIA or state public-records request from a plain-english ask</li>
            <li>Turns vague curiosity into a search query that finds the right document</li>
            <li>Points at the correct agency, court, or database for the record you want</li>
            <li>Suggests appeal language when a request gets denied or stalled</li>
          </ul>
        </div>

        <div className="grid md:grid-cols-2 gap-4 mb-10">
          <div className="border border-sage-border p-4" data-testid="compass-feature-1">
            <div className="text-sm font-bold uppercase tracking-tight text-sage-text mb-1">FOIA drafter</div>
            <div className="text-xs text-sage-muted sage-prose">Federal, state, and municipal formats. Fee-waiver language for public-interest requests included.</div>
          </div>
          <div className="border border-sage-border p-4" data-testid="compass-feature-2">
            <div className="text-sm font-bold uppercase tracking-tight text-sage-text mb-1">Agency router</div>
            <div className="text-xs text-sage-muted sage-prose">Names the actual office that holds the record — not just the parent department.</div>
          </div>
          <div className="border border-sage-border p-4" data-testid="compass-feature-3">
            <div className="text-sm font-bold uppercase tracking-tight text-sage-text mb-1">Search-query rewrite</div>
            <div className="text-xs text-sage-muted sage-prose">Rewrites a fuzzy question into three sharp queries: web, scholarly, government.</div>
          </div>
          <div className="border border-sage-border p-4" data-testid="compass-feature-4">
            <div className="text-sm font-bold uppercase tracking-tight text-sage-text mb-1">Appeal helper</div>
            <div className="text-xs text-sage-muted sage-prose">When you get a denial, Compass turns it into an appeal citing the right exemption language.</div>
          </div>
        </div>

        <div className="mb-10">
          <h2 className="text-2xl font-bold uppercase tracking-tight text-sage-text mb-3">Ask Compass — anonymous</h2>
          <FreeConsultWidget
            role="compass-public-records"
            productSlug="compass"
            placeholder="Describe what you want to find (e.g. 'inspection records for a building', 'police body-cam policy in my city', 'grant recipients from Dept of Energy 2023')."
            ctaLabel="Ask Compass"
            disclaimer="Compass drafts and points. It does not submit requests for you. Sending, tracking, and appealing is your part."
          />
        </div>

        <div className="border-t border-sage-border pt-6 text-xs text-sage-muted sage-prose">
          Compass is free forever. Journalists, activists, and citizen watchdogs — this is yours. If your newsroom or non-profit wants a bulk-drafting version, reach out through the Contact door.
        </div>
      </div>
    </div>
  );
}
